export default function PHP_natcasesort() {
  return (
    <div>
      <h1>PHP_natcasesort</h1>
    </div>
  );
}
